import {
  menuImportBatchJobSchema,
  providerImportJobResponseSchema,
  restaurantImportJobSchema,
  type MenuImportBatchJob,
  type ProviderImportJob,
  type RestaurantImportJob,
} from '../model';
import { getOne, postOne } from './http';

export const providerImportApi = {
  /** Start (or recover) the one merchant-wide menu batch job. */
  importMenu(): Promise<MenuImportBatchJob> {
    return postOne('merchant/provider-import/menu', {}, menuImportBatchJobSchema);
  },

  /** Start (or recover) the restaurants import job. */
  importRestaurants(): Promise<RestaurantImportJob> {
    return postOne('merchant/provider-import/restaurants', {}, restaurantImportJobSchema);
  },

  /** Start (or recover) the categories import job. */
  importCategories(): Promise<RestaurantImportJob> {
    return postOne('provider-import/categories', {}, restaurantImportJobSchema);
  },

  /** Start (or recover) the promotions import job. */
  importPromotions(): Promise<RestaurantImportJob> {
    return postOne('provider-import/promotions', {}, restaurantImportJobSchema);
  },

  /** Read the current state and accumulated counters of an import job. */
  async getJob(
    jobId: string,
    options?: { signal?: AbortSignal },
  ): Promise<ProviderImportJob> {
    const result = await getOne(
      `merchant/provider-import/jobs/${jobId}`,
      providerImportJobResponseSchema,
      undefined,
      options,
    );
    return result.job;
  },
};
